module.exports = __webpack_public_path__ + "jpg/googlePlay.jpg?6a8165596cc5ac9a5e61fa901cc87152";